<template>
  <div class="container">
    <div class="page">
      <div class="p_list">
        <div>
          <div class="p_item">
            <div>
              <img src="../assets/images/pro/1.png">
            </div>
            <div>
              <div class="text">
                <div>BMS8.1</div>
                <div class="msg_img" @click="dialogVisible = true">
                  <img src="../assets/images/msg.png">
                </div>
              </div>
              <div class="btn">
                <button @click="dialogVisible = true">下载BOM</button>
                <button @click="dialogVisible = true">下载图纸</button>
              </div>
            </div>
          </div>
          <div class="p_item">
            <div>
              <img src="../assets/images/pro/2.png">
            </div>
            <div>
              <div class="text">
                <div>CSC8.1</div>
                <div class="msg_img" @click="dialogVisible = true">
                  <img src="../assets/images/msg.png">
                </div>
              </div>
              <div class="btn">
                <button @click="dialogVisible = true">下载BOM</button>
                <button @click="dialogVisible = true">下载图纸</button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="p_item">
            <div>
              <img src="../assets/images/pro/3.png">
            </div>
            <div>
              <div class="text">
                <div>长安跨越线束</div>
                <div class="msg_img" @click="dialogVisible = true">
                  <img src="../assets/images/msg.png">
                </div>
              </div>
              <div class="btn">
                <button @click="dialogVisible = true">下载BOM</button>
                <button @click="dialogVisible = true">下载图纸</button>
              </div>
            </div>
          </div>
          <div class="p_item">
            <div>
              <img src="../assets/images/pro/4.png">
            </div>
            <div>
              <div class="text">
                <div>智行鸿远线束</div>
                <div class="msg_img" @click="dialogVisible = true">
                  <img src="../assets/images/msg.png">
                </div>
              </div>
              <div class="btn">
                <button @click="dialogVisible = true">下载BOM</button>
                <button @click="dialogVisible = true">下载图纸</button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="p_item">
            <div>
              <img src="../assets/images/pro/5.png">
            </div>
            <div>
              <div class="text">
                <div>交流模式二充电枪</div>
                <div class="msg_img" @click="dialogVisible = true">
                  <img src="../assets/images/msg.png">
                </div>
              </div>
              <div class="btn">
                <button @click="dialogVisible = true">下载BOM</button>
                <button @click="dialogVisible = true">下载图纸</button>
              </div>
            </div>
          </div>
          <div class="p_item">
            <div>
              <img src="../assets/images/pro/6.png">
            </div>
            <div>
              <div class="text">
                <div>欧标车端交流充电枪</div>
                <div class="msg_img" @click="dialogVisible = true">
                  <img src="../assets/images/msg.png">
                </div>
              </div>
              <div class="btn">
                <button @click="dialogVisible = true">下载BOM</button>
                <button @click="dialogVisible = true">下载图纸</button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="p_item">
            <div>
              <img src="../assets/images/pro/7.png">
            </div>
            <div>
              <div class="text">
                <div>1.27/2.54mm Pitch FFC</div>
                <div class="msg_img" @click="dialogVisible = true">
                  <img src="../assets/images/msg.png">
                </div>
              </div>
              <div class="btn">
                <button @click="dialogVisible = true">下载BOM</button>
                <button @click="dialogVisible = true">下载图纸</button>
              </div>
            </div>
          </div>
          <div class="p_item">
            <div>
              <img src="../assets/images/pro/8.png">
            </div>
            <div>
              <div class="text">
                <div>1.27/2.54mm Pitch FFC</div>
                <div class="msg_img" @click="dialogVisible = true">
                  <img src="../assets/images/msg.png">
                </div>
              </div>
              <div class="btn">
                <button @click="dialogVisible = true">下载BOM</button>
                <button @click="dialogVisible = true">下载图纸</button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="p_item">
            <div>
              <img src="../assets/images/pro/9.png">
            </div>
            <div>
              <div class="text">
                <div>护套</div>
                <div class="msg_img" @click="dialogVisible = true">
                  <img src="../assets/images/msg.png">
                </div>
              </div>
              <div class="btn">
                <button @click="dialogVisible = true">下载BOM</button>
                <button @click="dialogVisible = true">下载图纸</button>
              </div>
            </div>
          </div>
          <div class="p_item">
            <div>
              <img src="../assets/images/pro/10.png">
            </div>
            <div>
              <div class="text">
                <div>护线壳&支架</div>
                <div class="msg_img" @click="dialogVisible = true">
                  <img src="../assets/images/msg.png">
                </div>
              </div>
              <div class="btn">
                <button @click="dialogVisible = true">下载BOM</button>
                <button @click="dialogVisible = true">下载图纸</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <el-dialog
          :visible.sync="dialogVisible"
          width="760px"
          custom-class="dialog"
          :close-on-click-modal="false"
        >
          <div class="msg">
            <div>联系我们：<span @click="dialogVisible = false">×</span></div>
            <div>
              <div>
                <div>姓名 *</div>
                <input v-model="username">
              </div>
              <div>
                <div>邮箱 *</div>
                <input v-model="email">
              </div>
              <div>
                <div>公司</div>
                <input v-model="company">
              </div>
              <div>
                <div>手机号 *</div>
                <input v-model="mobile">
              </div>
              <div>
                <div>留言</div>
                <textarea name="" id="" cols="34" rows="3" v-model="messageDesc"></textarea>
              </div>
            </div>
            <div>
              <button @click="addMsg">提交</button>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      username:'',
      email:'',
      mobile:'',
      company:'',
      messageDesc:''
    };
  },
  methods: {
    addMsg() {
      this.dialogVisible = false;
      var username = this.username;
      var email = this.email;
      var company = this.company;
      var mobile = this.mobile;
      var messageDesc = this.messageDesc;
      // ajax请求
      var url = "tyMessage/saveMessage";
      var obj = {username,email,mobile,company,messageDesc};
      this.axios.post(url,this.qs.stringify(obj))
      .then(res=>{
        console.log(res.data)
        if(res.data.code==0){
          this.$message({
            type: 'info',
            message:'提交成功'
          });
        } else {
          this.$message({
            type: 'info',
            message:'提交失败'
          });
        }
      })
    }
  }
}
</script>

<style scoped>
/* 商品列表 */
.p_list {
  margin-top: -50px;
   margin-left: -26px;
}
.p_list>div {
  display: flex;
}
.p_item {
  display: flex;
}
.p_item:nth-child(2) {
  margin-left: 42px;
}
.p_item>div:first-child {
  width: 250px;
  height: 140px;
  margin: 42px 32px 0 0;
}
.p_item>div:nth-child(2) {
  margin-top: 63px;
  text-align: left;
}
.text {
  display: flex;
  font-size:16px;
  font-weight:600;
  color:rgba(34,34,34,1);
  line-height:24px;
}
.msg_img {
  width: 20px;
  height: 20px;
  overflow: hidden;
  position: relative;
  margin-left: 18px;
}
.msg_img>img {
  width: 45px;
  height: 65px;
  position: absolute;
  left: -16px;
  top: -10px;
}
.msg_img>img:hover {
  top: -32px;
}
/* 按钮 */
.p_item .btn {
  display: flex;
  margin-top: 22px;
}
.p_item .btn>button {
  width: 109px;
  height: 32px;
  background:#fff;
  border-radius:16px;
  border:1px solid rgba(0,0,0,1);
  font-size:14px;
  font-weight: 400px;
  line-height: 24px;
}
.p_item .btn>button:first-child {
  margin-right: 18px;
}
.p_item .btn>button:hover {
  background-color: #000;
  color: #fff;
}
/* 留言框 */
.msg {
  width: 540px;
  height: 582px;
  text-align: left;
  box-shadow:0px 5px 12px 4px rgba(119,119,119,0.09);
  margin-right: 0 !important;
}
.msg>div {
  padding-left: 18px;
  padding-right: 18px;
  margin-bottom: 12px;
}
.msg>div:first-child {
  height: 52px;
  background-color: #000;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  line-height: 52px;
}
.msg>div:first-child>span {
  position: absolute;
  right: 18px;
  font-size: 24px;
  cursor: default;
}
.msg>div:nth-child(2)>div {
  height: 66px;
  font-size: 14px;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height: 24px;
  margin-bottom: 12px;
  margin-right: 18px;
}
.msg>div:nth-child(2)>div:last-child {
  margin-bottom: 14px;
}
.msg>div:nth-child(2)>div>div:first-child {
  margin-bottom: 6px;
}
.msg>div:nth-child(2)>div>input {
  width:100%;
  height:36px;
  border-radius:2px;
  border:1px solid rgba(151,151,151,1);
  padding-left: 18px;
  font-weight: 14px;
}
.msg>div:nth-child(2)>div>textarea {
  width: 468px;
  height: 110px;
  border-radius:2px;
  border:1px solid rgba(151,151,151,1);
  outline: 0;
  padding: 0 18px;
  font-weight: 14px;
  line-height: 24px;
  overflow: auto;
}
.msg button {
  width:140px;
  height:36px;
  background:rgba(0,0,0,1);
  border-radius:28px;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  margin-left: 182px;
  z-index: 1;
  position: absolute;
  bottom: 16px;
}
.page /deep/ .dialog {
  width: 540px !important;
  height: 582px;
}
.page /deep/ .el-dialog__header {
  display: none;
}
.page /deep/ .el-dialog__body {
  padding: 0;
  width: 540px;
  margin-right: 0 !important;
}
</style>